(function () {
    angular.module("EventListApp").factory('SpinnerService', function () {
        var spinners = {};
        return {
            _register: function (data) {
                if (!data.hasOwnProperty('name')) {
                    console.log("Spinner must specify a name when registering with the spinner service");
                }
                spinners[data.name] = data;
            },
            _unregister: function (name) {
                if (spinners.hasOwnProperty(name)) {
                    delete spinners[name];
                }
            },
            _unregisterGroup: function (group) {
                for (var name in spinners) {
                    if (spinners[name].group === group) {
                        delete spinners[name];
                    }
                }
            },
            _unregisterAll: function () {
                for (var name in spinners) {
                    delete spinners[name];
                }
            },
            Show: function (name) {
                var spinner = spinners[name];
                if (!spinner)
                    return false;

                spinner.show();
            },
            Hide: function (name) {
                var spinner = spinners[name];
                if (!spinner)
                    return false;

                spinner.hide();
            },
            ShowGroup: function (group) {
                var groupExists = false;
                for (var name in spinners) {
                    var spinner = spinners[name];
                    if (spinner.group === group) {
                        spinner.show();
                        groupExists = true;
                    }
                }
                if (!groupExists) {
                    console.log("No spinners found with group '" + group + "'.")
                    return false;
                }
            },
            HideGroup: function (group) {
                var groupExists = false;
                for (var name in spinners) {
                    var spinner = spinners[name];
                    if (spinner.group === group) {
                        spinner.hide();
                        groupExists = true;
                    }
                }
                if (!groupExists) {
                    console.log("No spinners found with group '" + group + "'.")
                    return false;
                }
            },
            ShowAll: function () {
                for (var name in spinners) {
                    spinners[name].show();
                }
            },
            HideAll: function () {
                for (var name in spinners) {
                    spinners[name].hide();
                }
            }
        };
    });

})();